<template lang="html">
  <span class="btn-wrapper" :class="{'is-block': isBlock}">
    <button
      :disabled="isDisabled"
      @click="click"
      :class="[
        'btn',
        {'is-loading': isLoading},
        {'is-primary': primary},
        {'is-primary-invert': primaryInvert},
        {'is-secondary': secondary},
        {'is-tertiary': tertiary},
        {'has-tooltip': tooltip},
        {'has-icon': hasIcon},
        {'is-subtle': subtle},
        {'is-pulsing': pulse}
      ]">

      <Tooltip v-if="tooltip" :content="tooltip"/>

      <transition name="fade" mode="out-in">
        <img
          class="btn-loading"
          :src="require('../assets/loading.svg')"
          v-if="isLoading">
      </transition>

      <span><slot /></span>
    </button>
  </span>
</template>

<script>
import Tooltip from '@/components/Tooltip'

export default {
  name: 'Btn',

  props: {
    isLoading: {
      type: Boolean,
      default: false
    },

    isDisabled: {
      type: Boolean,
      default: false
    },

    isBlock: {
      type: Boolean,
      default: false
    },

    pulse: {
      type: Boolean,
      default: false
    },

    primary: {
      type: Boolean,
      default: false
    },

    primaryInvert: {
      type: Boolean,
      default: false
    },

    secondary: {
      type: Boolean,
      default: false
    },

    tertiary: {
      type: Boolean,
      default: false
    },

    subtle: {
      type: Boolean,
      default: false
    },

    tooltip: {
      type: String
    },

    hasIcon: {
      type: Boolean,
      default: false
    }
  },

  components: {Tooltip},

  methods: {
    click() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/base/animations'
@import '../stylesheets/base/theme'

.btn-wrapper
  position: relative
  display: inline-block

  &.is-block
    display: block

  &.is-dark
    .btn
      background: #333
      color: #fff

  &.is-light
    .btn
      background: #fff
      color: #333

.btn, button
  background: none
  border: none
  cursor: pointer
  text-transform: uppercase
  font-weight: bold
  font-size: 12px
  letter-spacing: 1px
  padding: 10px 20px
  border-radius: 3px
  color: #fff
  display: inline-flex
  align-items: center
  justify-content: center

  &:disabled
    opacity: 0.75
    pointer-events: none

  span
    transition: opacity .2s ease-in-out

  &.is-loading
    cursor: not-allowed
    pointer-events: none

    span
      opacity: 0

  &.is-dark
    background: #333
    color: #fff

  &.is-light
    background: #fff
    color: #333

  &.is-pulsing
    animation: pulse 1s infinite ease-in-out

  .btn-loading
    height: 40px
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)

  &.has-icon
    border-radius: 8px
    padding: 0!important
    width: 30px
    height: 30px
    display: flex
    align-items: center
    justify-content: center
    transition: all .2s ease-in-out

    .sprite
      width: 15px
      height: 15px

  &.has-tooltip
    position: relative

    .builder-tip
      opacity: 0
      position: absolute
      bottom: auto
      top: 0
      left: 50%
      transform: translate(-50%, -20px)
      padding: 2px $gap-x-small
      height: auto
      width: 130px
      margin: 0
      box-shadow: none
      transition: all .2s ease-in-out
      pointer-events: none

      p
        font-size: 8px
        margin: auto

    &:hover
      .builder-tip
        opacity: 1
        transform: translate(-50%, -26px)

  &:focus
    outline: none

  &.is-primary
    color: #fff

    @include themify($themes)
      background: themed('color-primary')

  &.is-primary-invert
    background: #fff

    @include themify($themes)
      color: themed('color-primary')

  &.is-subtle
    color: #fff
    transition: background .2s ease-in-out
    background: rgba(0, 0, 0, 0.2)

    &:hover
      background: rgba(0, 0, 0, 0.3)

  &.is-secondary
    color: #fff

    @include themify($themes)
      background: themed('color-secondary')

  &.is-tertiary
    color: #fff

    @include themify($themes)
      background: themed('color-tertiary')

  &.is-small
    font-size: 10px
    padding: 5px
    margin-left: $gap-small

  .sprite
    width: 20px
    height: 20px

.btn-save
  padding: 15px
  width: 100%
  text-align: center

  .btn
    margin: auto
    padding: 18px 25px
    display: block

    @include themify($themes)
      background: themed('color-primary')
</style>
